export default __webpack_public_path__ + "static/media/close_modal.303802c9.svg";